import { render, staticRenderFns } from "./Area5.vue?vue&type=template&id=4c390e0e&scoped=true&"
import script from "./Area5.vue?vue&type=script&lang=js&"
export * from "./Area5.vue?vue&type=script&lang=js&"
import style0 from "./Area5.vue?vue&type=style&index=0&id=4c390e0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c390e0e",
  null
  
)

export default component.exports